import { render, staticRenderFns } from "./DescList.vue?vue&type=template&id=25a8681c&scoped=true&"
import script from "./DescList.vue?vue&type=script&lang=js&"
export * from "./DescList.vue?vue&type=script&lang=js&"
import style0 from "./DescList.vue?vue&type=style&index=0&id=25a8681c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a8681c",
  null
  
)

export default component.exports